import React, { useEffect, useState } from 'react';
import api from '../../services/api';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import Table from '../../components/Table';

function Populations() {
  const selectedCycle = useSelector(
    (state) => state.selectedCycle.selectedCycle
  );
  const [populations, setPopulations] = useState([]);
  const [openProgress, setOpenProgress] = useState(false);
  const dispatch = useDispatch();
  const location = useLocation();
  const id = location?.state?.id;
  const pond = location?.state?.pond;
  const searchText = location?.state?.searchText ?? '';

  const columns = [
    {
      title: 'Viveiro',
      field: 'cycle.pond.description',
      type: 'string',
      editable: 'never',
      hideFilterIcon: true,
    },
    {
      title: 'Remessa',
      field: 'lot.name',
      type: 'string',
      editable: 'never',
      hideFilterIcon: true,
    },
    {
      title: 'Data de Povoamento',
      field: 'date',
      type: 'date',
      hideFilterIcon: true,
      editable: 'never',
      dateSetting: { locale: 'pt-BR' },
    },
    {
      title: 'Tamanho restante do lote',
      field: 'lot.size_remain',
      hideFilterIcon: true,
      editable: 'never',
      render: (rowData) => (
        <span>
          {new Intl.NumberFormat('pt-BR').format(rowData.lot?.size_remain)}
        </span>
      ),
    },
    {
      title: 'Quantidade de Animais',
      field: 'quantity',
      hideFilterIcon: true,
      render: (rowData) => (
        <span>{new Intl.NumberFormat('pt-BR').format(rowData.quantity)}</span>
      ),
    },
  ];

  useEffect(() => {
    async function loadData() {
      try {
        const response = await api.get(
          `/populations/cycle-code/${selectedCycle.id}`,
          {
            params: id ? { cycle: id } : {},
          }
        );
        if (response.data.length === 0) {
          setOpenProgress(true);
        }
        if (response.data) {
          setPopulations(response.data);
          setOpenProgress(true);
        }
      } catch (err) {}
    }
    loadData();
  }, [selectedCycle, id]);

  function setData(newData) {
    const tempData = [];
    populations.map((population) =>
      population.id === newData.id
        ? tempData.push(newData)
        : tempData.push(population)
    );
    setPopulations(tempData);
  }

  // eslint-disable-next-line react/no-unstable-nested-components
  function CustomTitle() {
    return (
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
        }}
      >
        <div
          style={{
            fontWeight: 500,
            fontSize: '20px',
            fontFamily: 'Roboto',
            marginInlineEnd: '10px',
          }}
        >
          Povoamentos
        </div>
        {pond ? (
          <div
            style={{
              padding: '5px',
              marginLeft: 'auto',
              border: '1px solid black',
              borderRadius: '10px',
              fontWeight: 600,
            }}
          >
            {pond.description}
          </div>
        ) : null}
      </div>
    );
  }

  return (
    <Table
      title="Povoamentos"
      titleCustomized={<CustomTitle />}
      route="/populations/"
      routeAdd="/population/"
      columns={columns}
      data={populations}
      setData={setData}
      dataLoaded={openProgress}
      pond={pond}
      searchText={searchText}
    />
  );
}

export default Populations;
